import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api/client.js';
import { useEffect, useState } from 'react';

export function AccountActivity({ address }: { address: string }) {
  const client = useQueryClient();
  const [notice, setNotice] = useState('');
  const activity = useQuery({ queryKey: ['activity', address], queryFn: api.activity, enabled: !!address, refetchInterval: q => q.state.data?.jobs.some(j => j.state === 'processing') ? 5000 : 30000 });
  useEffect(() => {
    if (!address) return;
    let cancelled = false; let inFlight = false;
    const recover = async () => {
      if (inFlight || cancelled) return;
      inFlight = true;
      try {
        const base = JSON.parse(localStorage.getItem(`gilding_base_order:${address}`) ?? 'null');
        if (!base?.signature) return;
        const result = await api.confirmPayment(base.packId, base.signature);
        if (cancelled) return;
        if (result.ok) {
          localStorage.removeItem(`gilding_base_order:${address}`);
          setNotice('Payment received. Your leaves are ready.');
          void client.invalidateQueries({ queryKey: ['me'] }); void activity.refetch();
        } else setNotice('Your payment is still confirming. Do not pay again.');
      } catch { if (!cancelled) setNotice('Your payment receipt is saved. Open purchases to retry confirmation.'); } finally { inFlight = false; }
    };
    void recover(); const timer = window.setInterval(() => void recover(), 10000);
    return () => { cancelled = true; window.clearInterval(timer); };
  }, [address, client]);
  return <section className="space-y-5">
    <h2 className="heading-section">Your recent activity</h2>
    {notice && <p role="status" className="font-display text-ink-soft">{notice} <Link className="underline" to="/buy">Purchases</Link></p>}
    {activity.isError && <p role="status">Activity could not be refreshed. <button className="btn-ghost" onClick={() => void activity.refetch()}>Try again</button></p>}
    {activity.data?.jobs.slice(0, 5).map(job => <div key={job.id} className="flex flex-wrap items-center justify-between gap-3 border-b border-hairline pb-3">
      <div className="min-w-0"><p className="font-display">{job.label || 'Your gilding'}</p><p className="text-caption text-ink-soft">{job.state === 'done' ? 'Ready to view' : job.state === 'processing' ? 'Creating your gilding — safe to leave this page' : job.message || 'Checking status'}</p></div>
      {job.state === 'done' && <Link className="btn-secondary" to={`/result/${job.id}`}>View gilding</Link>}
    </div>)}
    <details className="border-b border-hairline pb-4"><summary className="cursor-pointer font-display">Purchase history</summary><div className="mt-4 space-y-3">
      {activity.data?.purchases.length ? activity.data.purchases.map(p => <a key={p.signature} className="flex flex-wrap justify-between gap-2 font-display text-caption underline underline-offset-4" target="_blank" rel="noreferrer" href={`https://basescan.org/tx/${p.signature}`}><span>{p.credits} leaves · USDC</span><span>{new Date(p.at).toLocaleDateString()} · Receipt ↗</span></a>) : <p className="text-caption text-ink-soft">New verified purchases will appear here.</p>}
    </div></details>
  </section>;
}
